import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-espaco-familia-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './espaco-familia-layout.component.html',
  styleUrl: './espaco-familia-layout.component.scss'
})
export class EspacoFamiliaLayoutComponent {

}
